<template>
  <div class="addTask">
    <div class="content">
      <nut-row>
        <span class="cell-title">任务名称</span>
        <nut-textinput
            v-model="taskName"
            placeholder="请输入内容"
            :clearBtn="!isDisable"
            :disabled="isDisable"
        />
      </nut-row>
      <nut-row>
        <span class="cell-title">任务分组</span>
        <nut-button block type="light" @click="switchActionSheet('isVisible1')" :msg="taskGroupId">
          {{ taskGroup }}
        </nut-button>
        <van-popup v-model="isVisible1" position="bottom" style="height:350px;">
          <van-picker
              show-toolbar
              :columns="menuItems2.map(res => {
              return res.name
            })"
              title="任务分组"
              @cancel="isVisible1 = false"
              @confirm="onConfirm"
          ></van-picker>
        </van-popup>
      </nut-row>
      <nut-row style="padding:10px 0;">
        <span class="cell-title">播放模式</span>

        <div class="progremList">
          <van-field name="radio">
            <van-radio-group v-model="radio" direction="horizontal" slot="input">
              <van-radio name="1">替换模式</van-radio>
              <van-radio name="2">追加模式</van-radio>
            </van-radio-group>
          </van-field>
        </div>
      </nut-row>
      <nut-row v-if="isDataBtnDisable" style="padding:10px 0;">
        <span class="cell-title">选择节目</span>
        <van-button block type="info" icon="plus" @click="showPrograms" :msg="taskGroupId"
                    class="selectProgramBtn">
          <!--选择节目-->
        </van-button>
        <div class="progremList">
          <nut-row v-for="(item,index) in progremArr" :key="index">
            <nut-col span="2">
              <van-icon name="/static/images/jiemu.png"/>
            </nut-col>
            <nut-col span="20"><span class="overtext">{{ item.name }}</span></nut-col>
            <nut-col span="2" style="text-align: right;">
              <van-icon name="cross" @click="moveProgram(item)"/>
            </nut-col>
          </nut-row>
        </div>
      </nut-row>

      <nut-row v-if="!isDataBtnDisable">
        <span class="cell-title">日期范围</span>
        <nut-row>
          <nut-col :span="11">
            <nut-button type="light" small @click="showgroup('sData')">
              <van-icon name="orders-o"/>
              {{ startData }}
            </nut-button>
          </nut-col>
          <nut-col :span="2" style="line-height:100%;height:100%;margin-top:10px;text-align: center">---
          </nut-col>
          <nut-col :span="11">
            <nut-button type="light" small @click="showgroup('eData')">
              <van-icon name="orders-o"/>
              {{ endData }}
            </nut-button>
          </nut-col>
        </nut-row>
      </nut-row>
      <nut-row v-if="!isDataBtnDisable">
        <span class="cell-title">时间范围</span>
        <nut-row>
          <nut-col :span="11">
            <nut-button type="light" small @click="showgroup('sTime')">
              <van-icon name="orders-o"/>
              {{ startTime }}
            </nut-button>
          </nut-col>
          <nut-col :span="2" style="line-height:100%;height:100%;margin-top:10px;text-align: center">---
          </nut-col>
          <nut-col :span="11">
            <nut-button type="light" small @click="showgroup('eTime')">
              <van-icon name="orders-o"/>
              {{ endTime }}
            </nut-button>
          </nut-col>
        </nut-row>
      </nut-row>
      <nut-row v-if="!isDataBtnDisable">
        <span class="cell-title">任务周期</span>
        <nut-col class="weekliWrap">
          <!--                    <div class="coverWrap" v-if="isDataBtnDisable"></div>-->
          <div class="weekli" @click="weekChoose('1')" :class="isActive1? 'active': ''">一</div>
          <div class="weekli" @click="weekChoose('2')" :class="isActive2? 'active': ''">二</div>
          <div class="weekli" @click="weekChoose('3')" :class="isActive3? 'active': ''">三</div>
          <div class="weekli" @click="weekChoose('4')" :class="isActive4? 'active': ''">四</div>
          <div class="weekli" @click="weekChoose('5')" :class="isActive5? 'active': ''">五</div>
          <div class="weekli" @click="weekChoose('6')" :class="isActive6? 'active': ''">六</div>
          <div class="weekli" @click="weekChoose('7')" :class="isActive7? 'active': ''">日</div>
        </nut-col>
      </nut-row>
      <div
          style="margin-top:20px;border-top:1px solid #ddd;height:50px;display: flex;justify-content: space-between;align-items: center">
        <van-button type="default" size="small" @click="back">返回</van-button>
        <van-button type="info" size="small" @click="confirmTask">确定</van-button>
      </div>
    </div>
    <nut-datepicker
        :is-visible="isShowStartData"
        title="请选择开始日期"
        type="date"
        startDate="1991-11-10"
        endDate="2100-10-05"
        :defaultValue="startData"
        @close="isShowStartData = false"
        @choose="startDataChoose"
    >
    </nut-datepicker>
    <nut-datepicker
        :is-visible="isShowEndData"
        title="请选择结束日期"
        type="date"
        startDate="1991-11-10"
        endDate="2100-10-05"
        :defaultValue="endData"
        @close="isShowEndData = false"
        @choose="endDataChoose"
    >
    </nut-datepicker>
    <nut-datepicker
        :is-visible="isShowStartTime"
        title="请选择开始时间"
        type="time"
        :defaultValue="startTime"
        @close="isShowStartTime = false"
        @choose="startTimeChoose"
    >
    </nut-datepicker>
    <nut-datepicker
        :is-visible="isShowEndTime"
        title="请选择结束时间"
        type="time"
        :defaultValue="endTime"
        @close="isShowEndTime = false"
        @choose="endTimeChoose"
    >
    </nut-datepicker>
    <!--        节目列表---底部弹出---开始-->
    <van-action-sheet
        v-model="isVisible3"
        :round="isRound"
        style="height:350px;"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4">
          <van-button @click="closeGroup(2)" type="danger" size="small"
                      style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;">
            取消
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">节目列表</van-col>
        <van-col :span="4">
          <van-button @click="confirmSend3" type="info" size="small"
                      style="width:100%;background:none;color:#1B89FA;border:none;line-height:40px;height:40px;text-indent: -4px;">
            确定
          </van-button>
        </van-col>
      </van-row>
      <div style="" class="equirpGroupContent scroll_p">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse class="scroll_p_li" v-model="activeNames3" @change="onCollapseChange3" accordion
                      style="height:300px;overflow-y: auto">
          <van-collapse-item v-for="(item,index) in programsMenuItems3" :key="index" :name="index"
                             :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <van-checkbox-group v-model="progrmasSelect3" @change="onCheckboxGroupChange3"
                                v-if="index === activeNames3">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in data_p"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    @click="toggle"
                    style="position: relative;"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2" shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>
    <!--        节目列表---底部弹出---结束-->
    <!--        终端列表---底部弹出---开始-->
    <van-action-sheet
        v-model="isVisible4"
        :round="isRound"
        style="height:350px;"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4">
          <van-button @click="closeGroup(3)" type="danger" size="small"
                      style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;">
            取消
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">设备列表</van-col>
        <van-col :span="4">
          <van-button @click="confirmSend4" type="info" size="small"
                      style="width:100%;background:none;color:#1B89FA;border:none;line-height:40px;height:40px;text-indent: -4px;">
            确定
          </van-button>
        </van-col>
      </van-row>
      <div class="equirpGroupContent scroll_m">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse class="scroll_m_li" v-model="activeNames4" @change="onCollapseChange4" accordion
                      style="height:300px;overflow-y: auto">
          <van-collapse-item v-for="(item,index) in terminalMenuItems4" :key="index" :name="index"
                             :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <!--            {{data_m[0].name}}-->
            <van-checkbox-group v-model="terminalSelect4" @change="onCheckboxGroupChange4"
                                v-if="index === activeNames4">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in data_m"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    :data-name="index2"
                    @click="toggle"
                    style="position: relative;"
                    :icon="item2.onlineState == '1' ? '/static/images/icon_dev_online.png' : '/static/images/icon_dev_disonline.png'"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2.clNo+'-'+item2.clId"
                                shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>
    <!--        终端列表---底部弹出---结束-->
  </div>
</template>

<script>
import qs from 'qs'
import {Toast} from 'vant'

export default {
  name: 'addTask',
  data() {
    return {
      isRound: false,
      isVisible1: false,
      taskName: `task-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`,
      isDisable: false,
      taskGroup: '选择任务组',
      taskGroupId: '',
      border: true,
      isShowStartData: false,
      isShowEndData: false,
      isShowStartTime: false,
      isShowEndTime: false,
      startData: '选择开始日期',
      endData: '选择结束日期',
      startTime: '00:00',
      endTime: '23:59',
      isActive1: true,
      isActive2: true,
      isActive3: true,
      isActive4: true,
      isActive5: true,
      isActive6: true,
      isActive7: true,
      weekArr: [true, true, true, true, true, true, true],
      menuItems2: [],
      groupList: [],
      parentPage: '',
      programesIds: [],
      isDataBtnDisable: false,
      pageTitle: '新建任务',
      isVisible3: false,
      activeNames3: '',
      programsMenuItems3: [],
      progrmasSelect3: [],
      programesMsg: '选择节目',
      showPicker: false,
      taskGroupNameIndex: '',
      taskGroupName: '',
      isVisible4: false,
      terminalMenuItems4: [],
      activeNames4: '',
      terminalSelect4: [],
      ceEtId: '',
      progremArr: [],
      btnDisable: false,
      allSelectedPrograms: [],
      radio: "1",
      dataList_p: [],
      data_p: [],
      index_p: 0,
      dataList_m: [],
      data_m: [],
      index_m: 0,
      index: 0
    }
  },
  computed: {},
  mounted() {
    document.title = "添加任务"

    if (this.$route.query.progremData) {
      this.btnDisable = true
      // 接收节目制作传过来的值


      this.$route.query.progremData.forEach(item => {
        if (item.pmName || item.name) {
          if (item.pmResolution) {
            this.progremArr.push({name: item.pmName || item.name + '(' + item.pmResolution + ')'})
          } else {
            this.progremArr.push({name: item.pmName || item.name + '(' + item.resolution + ')'})
          }
        }
        let pid = item.id || item.pmId
        item.pid = pid

        this.allSelectedPrograms.push(item)
      })
    } else {
      this.btnDisable = false
    }


    this.parentPage = this.$route.query.parentPage
    this.programesIds = this.$route.query.grogramIds



    if (this.$route.query.parentPage === 'taskdetail') {
      this.pageTitle = '修改任务'
      this.isDataBtnDisable = false
      this.isDisable = true
      this.taskName = this.$route.query.data.etName
      this.startData = this.$route.query.data.etStartDate
      this.endData = this.$route.query.data.etEndDate
      this.startTime = this.$route.query.data.etStartTime.split(':')[0] + ':' + this.$route.query.data.etStartTime.split(':')[1]
      this.endTime = this.$route.query.data.etEndTime.split(':')[0] + ':' + this.$route.query.data.etEndTime.split(':')[1]
      this.isActive1 = this.$route.query.data.etMon !== 'false'
      this.isActive2 = this.$route.query.data.etTue !== 'false'
      this.isActive3 = this.$route.query.data.etWed !== 'false'
      this.isActive4 = this.$route.query.data.etThur !== 'false'
      this.isActive5 = this.$route.query.data.etFri !== 'false'
      this.isActive6 = this.$route.query.data.etSat !== 'false'
      this.isActive7 = this.$route.query.data.etSun !== 'false'

      this.$ajax('/etv/selectEqTaskCategoryAll.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id == this.$route.query.data.etEcId) {
            this.taskGroup = arr[i].ecName
            this.taskGroupId = arr[i].id
          }
          arr2.push({name: arr[i].ecName, value: arr[i].id})
        }
        this.menuItems2 = arr2
        this.groupList = arr2
      })


    } else {
      this.isDataBtnDisable = true
      this.getNowDate()
      this.$ajax('/etv/selectEqTaskCategoryAll.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          arr2.push({name: arr[i].ecName, value: arr[i].id})
        }
        this.menuItems2 = arr2
        this.groupList = arr2
      })
    }
  },
  methods: {
    getNowDate() {
      let date1 = new Date()
      this.startData = date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate()
      this.endData = date1.getFullYear() + 1 + '-' + (date1.getMonth() + 1) + '-' + date1.getDate()
      this.startTime = '00:00'
      this.endTime = '23:59'
    },
    showgroup(res) {

      if (res == 'sData') {
        this.isShowStartData = true
      } else if (res == 'eData') {
        this.isShowEndData = true
      } else if (res == 'sTime') {
        this.isShowStartTime = true
      } else if (res == 'eTime') {
        this.isShowEndTime = true
      }
    },
    startDataChoose(res) {
      this.startData = res[3]
    },
    endDataChoose(res) {
      this.endData = res[3]
    },
    startTimeChoose(res) {
      this.startTime = res[2]
    },
    endTimeChoose(res) {
      this.endTime = res[2]
    },
    weekChoose(res) {
      if (res == '1') {
        if (this.isActive1) {
          this.isActive1 = false
          this.weekArr[0] = false
        } else {
          this.isActive1 = true
          this.weekArr[0] = true
        }
      } else if (res == '2') {
        if (this.isActive2) {
          this.isActive2 = false
          this.weekArr[1] = false
        } else {
          this.isActive2 = true
          this.weekArr[1] = true
        }
      } else if (res == '3') {
        if (this.isActive3) {
          this.isActive3 = false
          this.weekArr[2] = false
        } else {
          this.isActive3 = true
          this.weekArr[2] = true
        }
      } else if (res == '4') {
        if (this.isActive4) {
          this.isActive4 = false
          this.weekArr[3] = false
        } else {
          this.isActive4 = true
          this.weekArr[3] = true
        }
      } else if (res == '5') {
        if (this.isActive5) {
          this.isActive5 = false
          this.weekArr[4] = false
        } else {
          this.isActive5 = true
          this.weekArr[4] = true
        }
      } else if (res == '6') {
        if (this.isActive6) {
          this.isActive6 = false
          this.weekArr[5] = false
        } else {
          this.isActive6 = true
          this.weekArr[5] = true
        }
      } else if (res == '7') {
        if (this.isActive7) {
          this.isActive7 = false
          this.weekArr[6] = false
        } else {
          this.isActive7 = true
          this.weekArr[6] = true
        }
      }
    },
    switchActionSheet(res) {
      this[`${res}`] = !this[`${res}`]
    },
    confirmTask() {
      if (this.taskName === '') {
        Toast('请填写任务名称')
        return
      }

      if (this.$route.query.parentPage === 'taskdetail') {
        this.$ajax.post('/etv/updateEquipmentTask.json', qs.stringify({
          etName: this.taskName,
          etStartDate: this.startData,
          etStartTime: this.startTime + ':00',
          etEndDate: this.endData,
          etEndTime: this.endTime + ':00',
          etState: '1',
          playMode: this.radio,
          id: this.$route.query.data.id,
          etPlayMode: "1",
          etEcId: this.taskGroupId,
          etMon: this.isActive1,
          etTue: this.isActive2,
          etWed: this.isActive3,
          etThur: this.isActive4,
          etFri: this.isActive5,
          etSat: this.isActive6,
          etSun: this.isActive7,
        })).then(res => {
          Toast(res.data.msg)
        })
      } else if (this.$route.query.parentPage === 'taskList') {
        if (this.taskGroupId === '') {
          Toast('请选择任务分组')
          return
        }
        console.log(this.allSelectedPrograms);
        if (this.allSelectedPrograms.length == 0) {
          Toast('请选择节目')
          return
        }
        let arr2 = []
        this.allSelectedPrograms.forEach(item => {
          arr2.push({pmId: item.pid, disPlayNo: '1'})
        })

        let postData = {
          task: {
            name: this.taskName,
            level: this.radio,
            taskType: '1',
            startDate: this.startData,
            startTime: this.startTime + ':00',
            endDate: this.endData,
            endTime: this.endTime + ':00',
            etState: '1',
            // Mids: this.$route.query.grogramIds.toString,
            playMode: this.radio,
            etIsLinkScreeen: '1',
            ecId: this.taskGroupId,
            mon: this.isActive1,
            tue: this.isActive2,
            wed: this.isActive3,
            thur: this.isActive4,
            fri: this.isActive5,
            sat: this.isActive6,
            sun: this.isActive7,
            playTimes: '',
          },
          mould: arr2,
        }
        let _this = this
        this.$ajax.post('/etv/insertTaskAndBindMould.json', postData).then(res => {
          // _this.$router.push({ path: '/programs', query: { itemName: 'b'} })
          if (res.data.code == 0) {
            Toast(res.data.msg)
            _this.isVisible4 = true
            _this.getTerinalList()
            _this.ceEtId = res.data.data
          } else {
            Toast(res.data.msg)
          }


        })
      }
    },
    toggle() {
    },
    onConfirm(value, index) {
      this.isVisible1 = false
      this.taskGroupName = value
      this.taskGroupNameIndex = index
      this.taskGroup = value
      this.taskGroupId = this.menuItems2[index].value
    },
    closeGroup() {
      this.isVisible1 = false

      this.isVisible3 = false
      this.programsMenuItems3 = []
      this.isVisible4 = false
      this.terminalMenuItems4 = []
      /*if (res === 3) {
        this.$router.push({path: '/programs', query: {itemName: 'b'}})
      }*/
    },
    onCollapseChange3(activeNames3) {
      this.index = 0
      this.index_p = 0
      if (activeNames3 === '') {
        return
      }
      this.activeNames3 = activeNames3
      this.index_p = activeNames3

      if (this.programsMenuItems3[this.activeNames3].children.length > 0) {

        this.data_p = this.programsMenuItems3[this.activeNames3].children.slice(this.index, 15)
      } else {
        this.data_p = []
      }
    },
    confirmSend3() {
      this.programesMsg = '已选' + this.progrmasSelect3.length + '个节目'
      if (this.progrmasSelect3.length == 0) {
        Toast('请选择节目')
        return
      }


      let arr1 = this.progremArr
      let arr2 = this.allSelectedPrograms
      arr1.push(...this.progrmasSelect3)
      arr2.push(...this.progrmasSelect3)

      this.progremArr = this.moveSameData(arr1)
      this.allSelectedPrograms = this.moveSameData(arr2)

      this.isVisible3 = false
    },
    moveSameData(array) {
      let obj = {}
      let arr = array.reduce((cur, next) => {
        obj[next.pid] ? "" : obj[next.pid] = true && cur.push(next);
        return cur;
      }, [])
      return arr;
    },
    showPrograms() {
      let _this = this
      _this.isVisible3 = true
      this.$ajax.post('/etv/selectProCategoryProgramMouldTree.json', qs.stringify({
        type: '1',
      })).then(res => {
        _this.programsMenuItems3 = res.data.data.pcList


        const Terminal = document.getElementsByClassName('scroll_p_li')[0]
        Terminal.addEventListener('scroll', _this.handleScroll1)
      })
    },
    //分页加载
    handleScroll1() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll_p')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll_p_li')[0].clientHeight
      //真实高度
      if (clientHeight - 350 - scrollHeight < 40) {
        if (this.programsMenuItems3[this.activeNames3].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data_p = [...this.data_p, ...this.programsMenuItems3[this.activeNames3].children.slice(this.index * 15, this.index * 15 + 15)]
      }
    },
    handleScroll2() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll_m')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll_m_li')[0].clientHeight
      //真实高度
      if (clientHeight - 350 - scrollHeight < 40) {
        if (this.terminalMenuItems4[this.activeNames4].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data_m = [...this.data_m, ...this.terminalMenuItems4[this.activeNames4].children.slice(this.index * 15, this.index * 15 + 15)]
      }
    },
    onCheckboxGroupChange3() {
    },
    getTerinalList() {
      let _this = this
      this.$ajax('/etv/selectSeachClientTreeMobile.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          arr2.push({name: arr[i].name, value: arr[i].id, children: arr[i].children})
        }
        _this.terminalMenuItems4 = arr2

        const Terminal = document.getElementsByClassName('scroll_m_li')[0]
        Terminal.addEventListener('scroll', _this.handleScroll2)

      })
    },
    // 选择终端
    onCollapseChange4(activeNames4) {
      this.index = 0
      if (activeNames4 === '') {
        return
      }
      this.activeNames4 = activeNames4
      this.index_m = activeNames4
      if (this.terminalMenuItems4[this.activeNames4].children.length > 0) {
        this.data_m = this.terminalMenuItems4[this.activeNames4].children.slice(this.index, 15)
      } else {
        this.data_m = []
      }
    },
    onCheckboxGroupChange4() {
    },
    confirmSend4() {
      if (this.terminalSelect4.length == 0) {
        Toast('请选择设备')
        return
      }
      let _this = this
      let postData = {
        ceEtId: _this.ceEtId,
        clientNos: '',
        ids: '',
      }
      let terminalSelectedArr = _this.terminalSelect4
      let noArr = [], idArr = []
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        idArr.push(terminalSelectedArr[i].split('-')[1])
        noArr.push(terminalSelectedArr[i].split('-')[0])
      }
      postData.clientNos = noArr.join(',')
      postData.ids = idArr.join(',')
      this.$ajax.post('/etv/insertClientEqTask.json', qs.stringify(postData)).then(res => {
        if (res.data.code == 0) {
          Toast('任务发送成功')
          _this.$router.push({path: '/programs', query: {itemName: 'c'}})
        } else {
          Toast(res.data.msg)
        }
        _this.isVisible4 = false
        _this.terminalSelect4 = []
        _this.activeNames4 = ['1']
        _this.ceEtId = ''

      })
    },
    moveProgram(res) {
      let num = '', num2 = ''
      this.progremArr.forEach((item, index) => {
        if (res.pid == item.pid) {
          num = index;
        }
      })
      this.progremArr.splice(num, 1)
      this.allSelectedPrograms.forEach((item, index) => {
        if (res.pid == item.pid) {
          num2 = index;
        }
      })
      this.allSelectedPrograms.splice(num2, 1)
    },
    back() {
      this.$router.back()
    }
  },
}
</script>

<style lang="scss">
.addTask {
  height: calc(100% - 130px) !important;

  .selectProgramBtn {
    width: 30px;
    height: 20px;
    line-height: 20px;
    padding: 0;
    display: inline-block;
    float: right;
    margin-top: 4px;
  }

  .van-collapse-item__content {
    padding: 0 16px;
  }

  .van-collapse-item__wrapper {
    position: relative;

    .van-cell {

      .van-checkbox {
        justify-content: flex-end;
      }
    }
  }

  .van-action-sheet__header {
    /*background: #1B89FA;*/
    color: #1B89FA;
    border-bottom: 1px solid #ccc;

    .van-action-sheet__close {
      color: #000;
    }
  }

  .equirpGroupContent {
    max-height: 400px;
    width: 100%;
    overflow-y: auto;
  }


  .content {
    padding: 10px 20px 0 20px;
    height: calc(100% - 0px);
    overflow-y: auto;

    .progremList {
      padding: 0 20px;
      max-height: 200px;
      overflow-y: auto;
      background: #fff;

      .van-cell {
        padding: 10px 0;

        .van-radio-group {
          display: flex;
          justify-content: space-between;
        }
      }

      .nut-row {
        line-height: 40px;
        border-bottom: 1px solid #ddd;

        .nut-col {
          display: flex;
          align-items: center;
          height: 40px;
        }

        .van-icon {
          width: 20px;
          height: 20px;

          .van-image {
            width: 100%;
            height: 100%;

          }
        }
      }
    }

    .van-popup--bottom {

      .nut-row {
        margin-bottom: 10px;
        border-bottom: 1px solid #ebedf0;
      }
    }

    .cell-title {
      height: 30px;
      line-height: 30px;
    }

    .nut-button.small {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding: 0 8px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;

      span {
        display: flex;
        align-items: center;
      }
    }

    .weekliWrap {
      display: flex;
      justify-content: space-around;
      position: relative;

      .coverWrap {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
      }

      .weekli {
        width: 32px;
        height: 32px;
        background: #fff;
        border: 1px solid #1B89FA;
        color: #1B89FA;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .weekli.active {
        background: #1B89FA;
        color: #fff;
      }
    }
  }
}
</style>
